import { render, staticRenderFns } from "./AddRoleWindow.vue?vue&type=template&id=c4096892"
import script from "./AddRoleWindow.vue?vue&type=script&lang=js"
export * from "./AddRoleWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports